import Quill from "quill";

var Embed = Quill.import("blots/embed");

class SvgOld extends Embed {
  static create(value) {
    // Fillable, Raw, Content
    let temp = document.createElement('div');
    temp.innerHTML = value.content.trim();
    let svg = temp.querySelectorAll('svg')[0];
    const fillable = (svg.querySelectorAll('[fill]').length > 0) ? false : true;
    const raw = svg.outerHTML.replaceAll('\n', '').replaceAll('\t', '');
    svg.style.width = 'auto';
    svg.style.height = value.size;
    svg.style.fill = value.color;
    const content = svg.outerHTML;

    // const node = super.create(value.content);
    let node = super.create();
    node.setAttribute("data-ql-icon-fillable", fillable);
    node.setAttribute("data-ql-icon-name", value.name);
    node.setAttribute("data-ql-icon-size", value.size);
    node.setAttribute("data-ql-icon-color", value.color);
    node.setAttribute("data-ql-icon", raw);
    node.style.height = value.size;
    node.innerHTML = content;
    
    if (node.nodeName == 'ICON') {
      let nodeNew = document.createElement('span');
      nodeNew.classList.add("icon");
      nodeNew.setAttribute("data-ql-icon-fillable", fillable);
      nodeNew.setAttribute("data-ql-icon-name", value.name);
      nodeNew.setAttribute("data-ql-icon-size", value.size);
      nodeNew.setAttribute("data-ql-icon-color", value.color);
      nodeNew.setAttribute("data-ql-icon", raw);
      nodeNew.style.height = value.size;
      nodeNew.innerHTML = content;
      return nodeNew;
    }

    return node;
  }
  // static formats(domNode) {
  //   return {
  //     iconFillable: (domNode.getAttribute("data-ql-icon-fillable") === true || domNode.getAttribute("data-ql-icon-fillable") === 'true') ? true : false,
  //     iconName: domNode.getAttribute("data-ql-icon-name"),
  //     iconSize: domNode.getAttribute("data-ql-icon-size"),
  //     iconColor: domNode.getAttribute("data-ql-icon-color"),
  //     iconContent: domNode.getAttribute("data-ql-icon"),
  //   };
  // }
  static value(domNode) {
    if (domNode.parentNode && domNode.parentNode.getAttribute("isicon")) {
      let size = domNode.parentNode.getAttribute("iconsize");
      return {
        name: domNode.parentNode.getAttribute("iconname"),
        size: (size && !size.includes('px')) ? `${size}px` : size,
        color: domNode.querySelector('svg').style.fill,
        content: domNode.parentNode.getAttribute("iconcontent"),
      };
    } else if (domNode.previousElementSibling && domNode.previousElementSibling.getAttribute("isicon")) {
      let size = domNode.previousElementSibling.getAttribute("iconsize");
      return {
        name: domNode.previousElementSibling.getAttribute("iconname"),
        size: (size && !size.includes('px')) ? `${size}px` : size,
        color: domNode.querySelector('svg').style.fill,
        content: domNode.previousElementSibling.getAttribute("iconcontent"),
      };
    } else {
      return {
        name: null,
        size: '16px',
        color: domNode.querySelector('svg').style.fill,
        content: domNode.getAttribute("data-value"),
      };
    }
  }
}

SvgOld.blotName = "iconOld";
SvgOld.className = "iconOld";
SvgOld.tagName = "ICON";

export default SvgOld;